import { createFileRoute } from '@tanstack/react-router';
import { SignIn } from '@clerk/clerk-react';

export const Route = createFileRoute('/sign-in')({
  component: SignInPage,
});

function SignInPage() {
  return (
    <main style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: '2rem' }}>
      <div>
        <h1 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>Simplifica · Admin v2</h1>
        <SignIn routing="path" path="/sign-in" forceRedirectUrl="/socios" />
      </div>
    </main>
  );
}
